import TokenStorage from './token_storage';

export default class YakFetch {
  static async fetch(endpoint, method, options = {}) {
    const headers = YakFetch._setHeaders(options);
    const payload = {
      method: method,
      headers: headers,
      credentials: 'same-origin'
    }

    if (options.body) {
      payload.body = JSON.stringify(options.body);
    }

    return await fetch(endpoint, payload);
  }

  static _setHeaders(options) {
    let headers = { 'Content-Type': 'application/json' };
    const authToken = YakFetch._getAuthToken(options);

    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    return headers;
  }

  static _getAuthToken(options) {
    if (options.token) {
      return options.token;
    } else if (TokenStorage.getAuthToken()) {
      return TokenStorage.getAuthToken();
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/yak_fetch.js